<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">REGLAS Y ACUERDOS DEFINIDOS PARA LAS OPCIONES</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">

        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <div class="p-fluid">
                        <div class="p-field p-grid">
                            <label for="coordinput" class="p-col-8 p-mb-2 p-md-2 p-mb-md-0">Opción</label>
                            <div class="p-col-8 p-md-6">
                                <span class="p-text-bold">{{ findOptInput }}</span>
                            </div>
                            <div class="p-col-8 p-md-6">
                                <span class="p-text-bold p-error">{{textUser}}</span>
                            </div>

                            <!--p-button label="Buscar" icon="pi pi-search" class="p-mr-2 p-mb-2" (click)="findOption()"></p-button-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-table #dt [value]="lstOptionRules" [rows]="20" [paginator]="true" [globalFilterFields]="['key.sequence','summary','startingDate']"
                [(selection)]="selectedOptionRule" [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h5 class="p-m-0">Opciones {{findOptInput}}   </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                        </span>
                    </div>
                    
                    <span class="p-input-icon-left">
                        <button type="button" pButton pRipple icon="pi pi-plus" (click)="openNewOption()" class="p-mr-4" pTooltip="Agregar Opción" tooltipPosition="bottom" *ngIf="this.userCanEdit"></button>
                        <!--button type="button" pButton pRipple (click)="goBack()" class="p-mr-4" pTooltip="Regresar" tooltipPosition="bottom">Regresar</button-->
                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="storeId">Seq<p-sortIcon field="storeId"></p-sortIcon></th>
                        <th pSortableColumn="descri">Resúmen<p-sortIcon field="descri"></p-sortIcon></th>
                        <th pSortableColumn="type">Fecha<p-sortIcon field="type"></p-sortIcon></th>
                        <th >Descarga Archivo</th>
                        <th *ngIf="this.userCanEdit">Editar</th>
                        <th *ngIf="this.userCanEdit">Eliminar</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-option>
                    <tr>
                        <td>{{option.key.sequence }}</td>
                        <td>{{option.summary}}</td>
                        <td>{{option.startingDate | tovpilDate: 'd MMM y'}}</td>
                        <td>
                            <button type="button"  pButton pRipple icon="pi pi-download" *ngIf="option.eviedencefileName" class="p-button-rounded p-button-info mr-2" (click)="downloadEvidence(option)"></button>
                            <button type="button"  pButton pRipple icon="pi pi-download" *ngIf="!option.eviedencefileName" class="p-button-rounded p-button-info mr-2" disabled></button>
                        </td>
                        <td *ngIf="this.userCanEdit">
                            <button type="button"  pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" (click)="editOption(option)"></button>
                        </td>
                        <td *ngIf="this.userCanEdit">
                            <button type="button"  pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteOptionRule(option)"></button>
                        </td>
                    </tr>
                </ng-template>

                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            En total hay {{lstOptionRules ? lstOptionRules.length : 0 }} opciones.
                        </div>
                    </ng-template>
        </p-table>

        
    </div>

    <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="Detalle Opción" [modal]="true" styleClass="p-fluid" (onShow)="onShowModalOption()">
        <ng-template pTemplate="content">
            <div class="field">
                <label for="opt">Opción</label>
                <div class="p-col-12 p-md-10">
                    <span class="p-text-bold">{{ optionRule.key  ? optionRule.key.optionId : findOptInput }}</span>
                </div>
            </div>

            <div class="field">
                <label for="opt">Secuencia</label>
                <div class="p-col-12 p-md-10">
                    <span class="p-text-bold">{{ optionRule.key ? optionRule.key.sequence : ""}}</span>
                </div>
            </div>

            <div class="field">
                <label for="dateformat">Fecha Inicio Vigencia.</label>
                <p-calendar [(ngModel)]="optionRuleDate" dateFormat="dd-MM-yy" inputId="dateformat"  [showIcon]="true" inputId="icon"></p-calendar>
                <small class="p-error" *ngIf="submitted && !optionRuleDate">Se requiere Fecha Inicio.</small>
            </div>
            
            <div class="field col-12 md:col-4">
                <label for="summary">Resumen</label>
                <textarea id="summary" pInputTextarea [(ngModel)]="optionRule.summary"  required rows="3" cols="20"></textarea>
                <small class="p-error" *ngIf="submitted && !optionRule.summary">Se requiere Resumen.</small>
            </div>

            <div class="field col-12 md:col-4">
                <label for="fullDescription">Descripción Detallada</label>
                <textarea id="fullDescription" pInputTextarea [(ngModel)]="optionRule.fullDescription"  required rows="3" cols="20"></textarea>
                <small class="p-error" *ngIf="submitted && !optionRule.fullDescription">Se requiere Descripción Detallada.</small>
            </div>

            <p-fileUpload name="files"  [previewWidth]="0" [files]="uploadedFiles"
                    multiple="multiple"  maxFileSize="1000000" [customUpload]="true" (onSelect)="uploadEvent($event)" disables="true" fileLimit="1" chooseLabel="Seleccionar" [showUploadButton]="false" [showCancelButton]="false"> 
                <ng-template pTemplate="content">
                    <ul *ngIf="uploadedFiles.length">
                        <li *ngFor="let file of uploadedFiles">{{file.name}} - bytes</li>
                    </ul>
                </ng-template>
            </p-fileUpload>

    


        </ng-template>
    
        <ng-template pTemplate="footer">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" [loading]="loading" (click)="createOptionRule()"></button>
        </ng-template>
    </p-dialog>

</p-fieldset>